import { api } from '@shared/api/api';

type TimeTrackingEntry = App.Domain.TimeTracking.Data.TimeTrackingEntryData;
export type UpdateTimeTrackingEntryRequest = App.Http.Requests.TimeTracking.UpdateTimeTrackingEntryRequest;

export const updateTimeTrackingEntry = api.createUpdate<UpdateTimeTrackingEntryRequest, TimeTrackingEntry>(
  'time-tracking-entries/:id'
);
